<template>
	<div>
		<div class="card-section">
			<div class="container">
				<div class="card-block bg-white mb30" style="box-shadow:4px 18px 22px aliceblue">
					<div class="row">
						<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
							<!-- section-title -->
							<div class="section-title mb-0">
								<form-wizard :finish-button-text="$t('message.FINISH')" :back-button-text="$t('message.BACK')" :next-button-text="$t('message.NEXT')" @on-complete="onComplete" @on-change="stepChange" title="" subtitle="" color="#40ac67" error-color="#ff4949" style="margin-bottom:60px;">
									<tab-content title="1" icon="ti-user" :before-change="validateFirstStep">
										<div class="">
											
											<h4 style="padding-bottom:20px"> {{ $t('message.CONFIRM_YOUR_DATA')}} </h4>
											<div class="row">
												<div class="col-md-6 form-group">
													<label class="label">{{ $t('message.NAME')}}</label>
													<input name="name" v-model="name" type="text" class="form-control" v-validate="'required'" :class="{'is-invalid': errors.has('name') }" autocomplete="off"> 
													<span v-show="errors.has('name')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD') }}</span> </div>
												<div class="col-md-6 form-group">
														<label class="label">{{ $t('message.EMAIL')}}</label>
														<input name="email" v-model="email"  type="email" class="form-control" v-validate="'required'" :class="{'is-invalid': errors.has('email') }" autocomplete="off"> 
														<span v-show="errors.has('email')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD') }}</span> </div>
												<div class="col-md-6 form-group">
													<label class="label">CVR Nummer</label>
													<input name="cvr" v-model="cvr" type="number" class="form-control" v-validate="'required|min:8|max:8'"  :class="{'is-invalid': errors.has('cvr') }" autocomplete="off"> 
													<span v-show="errors.has('cvr')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD_MIN_8') }}</span> </div>
												<div class="col-md-6 form-group">
													<label class="label">{{ $t('message.TRUCK_NUMBER')}} </label>
													<input name="dr_number" v-model="dr_number" type="number" class="form-control" v-validate="'required|min:6|max:6'" :class="{'is-invalid': errors.has('dr_number') }" autocomplete="off"> 
													<span v-show="errors.has('dr_number')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD_MIN_6') }}</span> </div>
												<div class="col-md-6 form-group">
													<label class="label">{{ $t('message.TELEPHONE')}}</label>
													<input name="phone" v-model="phone" type="number" class="form-control" v-validate="'required'" :class="{'is-invalid': errors.has('phone') }" autocomplete="off"> 
													<span v-show="errors.has('phone')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD') }}</span>
												</div>
												<div class="col-md-6 form-group">
													<label class="label">{{ $t('message.UNDERVOGN')}}</label>
													<input name="undervogn" v-model="undervogn" type="text" class="form-control" :class="{'is-invalid': errors.has('undervogn') }" autocomplete="off"> 
													<span v-show="errors.has('undervogn')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD') }}</span>
												</div>
												<div class="col-md-6 form-group">
													<b-form-checkbox id="checkbox-1" v-model="car" class="mr-4" name="checkbox-1" value="1" unchecked-value="0">
														{{ $t('message.CAR') }} 
													</b-form-checkbox>
												</div>
												<div class="col-md-6 form-group">
													<b-form-checkbox id="checkbox-2" v-model="work" name="checkbox-2" value="1" unchecked-value="0">
														{{ $t('message.INSURANCE') }} 
													</b-form-checkbox>
            									</div>
												<div class="col-md-6" v-if="car=='1'">
													<label class="label">{{ $t('message.CAR_NUMBER') }}</label>
													<input name="reg_number" v-model="reg_number" type="text" class="form-control" v-validate="no_license == '0' ? 'required' : ''" :class="{'is-invalid': errors.has('reg_number') }" autocomplete="off"> 
													<span v-show="errors.has('reg_number')" class="invalid-feedback">{{$t('message.REQUIRED_FIELD') }}</span>
												</div>
												<div class="col-md-6" v-if="car=='1'">
													<b-form-checkbox id="no_license" v-model="no_license" class="mr-4 pt-5" name="no_license" value="1" unchecked-value="0">
														{{ $t('message.DO_NOT_HAVE_REG')}}
													</b-form-checkbox>
												</div>
												<div class="row" v-if="car=='1'">
													
												</div>
											</div>
											<br />
											<h4 style="padding-bottom:20px">  {{ $t('message.YOUR_ADDRESS')}} </h4>
											<div class="row">
												<div class="col-md-6 form-group">
													<label class="label">Adresse</label>
													<input name="address" v-model="address" type="text" class="form-control" v-validate="'required'" :class="{'is-invalid': errors.has('address') }" autocomplete="off"> 
													<span v-show="errors.has('address')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD') }}</span> </div>
												<div class="col-md-6 form-group">
													<label class="label">{{ $t('message.ZIP_CODE')}}</label>
													<input name="zip_code" v-model="zip_code" type="text" class="form-control" v-validate="'required'" :class="{'is-invalid': errors.has('zip_code') }" autocomplete="off"> 
													<span v-show="errors.has('zip_code')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD') }}</span> </div>
												<div class="col-md-6 form-group">
													<label class="label">{{ $t('message.CITY')}}</label>
													<input name="city" v-model="city" type="text" class="form-control" v-validate="'required'" :class="{'is-invalid': errors.has('city') }" autocomplete="off"> 
													<span v-show="errors.has('city')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD') }}</span> </div>
											</div>

											<!-- <b-form-group :label="$t('message.ANY_INSURANCE')">
												<b-form-radio-group
													id="radio-group-2"
													name="some-radios"
												>
													<b-form-radio id="previous_insurance_1" value="1" v-model="previous_insurance">{{ $t('message.YES')}}</b-form-radio>
													<b-form-radio id="previous_insurance_2" value="0" v-model="previous_insurance">{{ $t('message.NO')}}</b-form-radio>
												</b-form-radio-group>
											</b-form-group> -->

											<h5> {{ $t('message.ANY_INSURANCE')}} </h5>
											<div class="row">
												<div class="form-group col-sm-1"> 
													<b-form-radio name="some-radios" id="previous_insurance_1" v-model="previous_insurance" value="1">{{ $t('message.YES')}}</b-form-radio>
												</div>
												<div class="form-group col-sm-1"> 
													<b-form-radio name="some-radios" id="previous_insurance_2" v-model="previous_insurance">{{ $t('message.NO')}}</b-form-radio>
												</div>
											</div>
										</div>
									</tab-content>
									<tab-content title="2" icon="ti-money" :before-change="validateSecondStep">
										<!-- <div class="col-sm-12" style="background:gainsboro; padding:25px;margin-bottom: 15px;" id="step-2-infobox">
											<h5>{{ $t('message.WHERE_DO_YOUR_DRIVER')}} </h5>
											<p style="font-size:13px"> {{$t('message.STEP_2_MSG')}} </p> 
											<h5> {{$t('message.INJURIES_NUMBER')}} </h5> 
											<p style="font-size:13px"> {{$t('message.MANY_INJURIES')}} </p> 
											<h5 > {{$t('message.ROAD_SIDE')}} </h5>
											<p style="font-size:13px">
												{{$t('message.THOMAS')}} <a href="https://www.eadk.dk/eadk_vejhjaelp_1_02.pdf">{{$t('message.TERMS')}}</a>
											</p>
											<h5> {{$t('message.GLASS_DAMAGE')}} </h5>
											<p style="font-size:13px"> {{$t('message.CONNECTION_WITH_GLASS')}} </p>
											<h5> {{$t('message.OPERATING_LOSS')}} </h5>
											<p style="font-size:13px"> {{$t('message.COMPENSATION_PER')}} </p>
											<h5> {{$t('message.QUESTION')}} </h5>

											
											<p style="font-size:13px"> {{$t('message.CONTACT')}} <a href = "mailto:forsikring@dantaxi.dk" style="font-weight: bold;
											text-decoration: underline;
											font-size: 14px;
											color: rgba(43,172,102,255);">forsikring@dantaxi.dk</a> </p> 
										</div> -->
										<div class="row">
											<div class="col-md-12">
									          	<h4 style="padding-bottom:20px"> {{ $t('message.CAR')}}</h4>
											</div>
										    <div class="col-md-6 form-group">
												<label class="label">{{ $t('message.NEW_VALUE')}}</label>
												<v-select name="new_value" :options="new_values" v-model="new_value" :class="{'is-invalid': errors.has('new_value')}" @input="get_premium"></v-select>
                								<span v-show="new_value == null && step2 == true" class="invalid-field">{{ $t('message.REQUIRED_FIELD') }}</span>
                                            </div>
											 <div class="col-md-6 form-group">
												<label class="label">{{ $t('message.OWN_RISK')}}</label>
												<v-select name="own_risk" :options="own_risks" v-model="own_risk" :class="{'is-invalid': errors.has('own_risk')}" @input="get_premium"></v-select>
                								<span v-show="own_risk == null && step2 == true" class="invalid-field">{{ $t('message.REQUIRED_FIELD') }}</span>
                                            </div>
											<div class="col-md-6 form-group">
												<label class="label"> {{ $t('message.WHERE_DO_YOUR_DRIVER')}}</label>
												<v-select name="area" :options="areas" v-model="area" :class="{'is-invalid': errors.has('area')}" @input="get_premium"></v-select>
                								<span v-show="area == null && step2 == true" class="invalid-field">{{ $t('message.REQUIRED_FIELD') }}</span>
                                            </div>
											<div class="col-md-6 form-group">
												<label class="label"> {{ $t('message.INJURIES')}}</label>
												<v-select name="injury" :options="injuries" v-model="injury" :class="{'is-invalid': errors.has('injury')}" @input="get_premium"></v-select>
                								<span v-show="injury == null && step2 == true" class="invalid-field">{{ $t('message.REQUIRED_FIELD') }}</span>
                                            </div>
										</div>
										<br/>
										<div v-for="(car_add_on, index) in car_add_ons" :key="index">
											    <h5> {{car_add_on.name}} </h5>
												<div style="">
												<div class="row">
													<div class="form-group col-sm-1"> 
														<b-form-radio v-model="car_add_on_model[index]" :value="car_add_on.price">{{ $t('message.YES')}}</b-form-radio>
													</div>
													<div class="form-group col-sm-1"> 
														<b-form-radio v-model="car_add_on_model[index]" :value="'0'">{{ $t('message.NO')}}</b-form-radio>
													</div>
													<div class="col-md-12"
													  v-if="index == 0 && car_add_on_model[0] != '0' && car_add_on_model[0] != null && car_add_on_model[0] != ''">
														<div class="col-md-6 form-group">
															<label for="addOn1Date" class="label">Vejhjælp aktiv pr.:</label>
															<b-form-datepicker
																id="addOn1Date"
																v-model="addOn1Date"
																class="form-control"
																locale="da-DK"
															></b-form-datepicker>
														</div>
													</div>
												</div>
												<span v-show="car_add_on_model[index] == null && step2 == true" class="invalid-field">{{ $t('message.REQUIRED_FIELD') }}</span>
												</div>
											<br />
										</div>	
										<div class="col-md-12"	>   
											<h4 style="text-align: end;"> {{ $t('message.CAR')}} {{ $t('message.PRICE')}} {{car_price}} DKK / {{ $t ('message.MONTHLY')}} </h4>
										</div>	
										<!-- <div class="float-right"  v-show="status == true" ><a href="#" @click="$bvModal.show('insurrance-ons')"  class="text-dabger">{{ $t('message.EXISTING_CAR_INSURANCE')}} </a></div><br> -->
										
											
											 <b-modal id="insurrance-ons" ref="insurrance-ons" size="lg" hide-footer :title="$t('message.TERMINATION_EXISTING_CAR')" :no-close-on-backdrop="true">
												<div class="row">
													<div class="col-md-6 form-group">
														<label class="label">{{ $t('message.INSURANCE_COMPANY')}}</label> 
														<v-select :options="insurance" v-model="select_insurance" class="as-input-ht"></v-select>
													</div>
													<div class="col-md-6 form-group">
														<label class="label">{{ $t('message.POLICE_NUMBER')}}</label>
														<input type="text" v-model="police_number" class="form-control" >
													</div>
													<div class="col-md-6 form-group">
														<label class="label">{{ $t('message.DATE_OF_TERMINATION')}}</label>
                                						<i class='fas fa-calendar-week' style="position: absolute; top: 50px; left: 345px;" />
                                                    	<Datetime aria-describedby="date-resgister-feedback"   id="date-resgister" name="date-resgister-feedback" v-model="date"  format="dd-MM-yyyy" type="date" class="form-control is-invalid'"/>
													</div>
												</div>
											<br />
											<hr>
												<span class="float-right">
												<b-button class="btn btn-info mr-2"   @click="add_insurance()">{{ $t('message.NEXT')}}</b-button>
												<b-button class=" btn btn-danger"   @click="$bvModal.hide('insurrance-ons')">{{ $t('message.CLOSE')}}</b-button>
												</span>

											</b-modal>													
										
								    </tab-content>
									<tab-content title="3" icon ="ti-check" :before-change="validateThirdStep">
										<div class="row">
												<!-- <div class="col-sm-12" style="background:gainsboro; padding:25px;margin-bottom: 15px;">
												<h5>{{ $t('message.YOUR_DRIVERS')}} </h5>
												<p style="font-size:13px"> {{$t('message.STEP_3_MSG')}} </p> 
											    <h5> {{$t('message.QUESTION')}} </h5>
												<p style="font-size:13px"> {{$t('message.CONTACT')}} <a href = "mailto:forsikring@dantaxi.dk" style="font-weight: bold;
												text-decoration: underline;
												font-size: 14px;
												color: rgba(43,172,102,255);">forsikring@dantaxi.dk</a> </p> 
												
											</div> -->

											<!-- <div class="col-md-12">
									          	<h4 style="padding-bottom:20px"> {{ $t ('message.DO_YOU_WANT_TAKE_OCCUPATIONAL_INJURY')}}</h4>
											</div> -->
											<br />
											<div v-for="(work_add_on, index) in work_add_ons" :key="index">
												<div class="col-md-12">
													<h5> {{work_add_on.name}} </h5>
													<div style="">
													<div class="row">
														<div class="form-group col-sm-3"> 
															<b-form-radio v-model="work_add_on_model[index]" :value="work_add_on.price">{{ $t ('message.YES')}}</b-form-radio>
														</div>
														<div class="form-group col-sm-3"> 
															<b-form-radio style="margin-right:85px" v-model="work_add_on_model[index]" :value="'0'">{{ $t ('message.NO')}}</b-form-radio>
														</div>
													</div>
													<span v-show="work_add_on_model[index] == null && step3 == true" class="invalid-field">{{ $t('message.REQUIRED_FIELD') }}</span>
													</div>
												</div>	
												<br />
											</div>
											<div class="col-md-12" v-if="work_add_on_model[0] != '0' && work_add_on_model[0] != null && work_add_on_model[0] != ''">
												<div class="col-md-6 form-group">
													<label class="label"> {{ $t('message.NUMBER_OF_CARS')}}</label>
													<input type="number" min="0" v-model="cars" class="form-control" >
												</div>
												<div class="col-md-12 form-group">
													<label class="label"> {{ $t('message.NUMBER_OF_EMPLOYEES')}}</label>
													<label class="label"> {{ $t('message.NUMBER_OF_EMPLOYEES_DESC')}}</label>
												</div>
												<div class="col-md-6 form-group">
													<input type="number" min="0" v-model="employees" class="form-control" >
												</div>
												<div class="col-md-6 form-group">
													<label for="injuryValidFrom" class="label">Arbejdsskade gyldig fra:</label>
    												<b-form-datepicker
													  id="injuryValidFrom"
													  v-model="injuryValidFrom"
													  class="form-control"
													  locale="da-DK"
													></b-form-datepicker>
												</div>
												<div class="col-md-6 form-group">
													<label for="injuryComment" class="label">Kommentar til arbejdsskade:</label>
													<b-form-textarea
														id="injuryComment"
														v-model="injuryComment"
														placeholder="Kommentar til arbejdsskade..."
														rows="3"
														max-rows="6"
													></b-form-textarea>
												</div>
												<!-- <div class="col-md-6 form-group">
													<label class="label"> {{ $t('message.DRIVERS')}}</label>
													<div class="row">
														<div class="form-group col-sm-2"> 
															<b-form-radio v-model="drivers" :value="'0'">0</b-form-radio>
														</div>
														<div class="form-group col-sm-2"> 
															<b-form-radio v-model="drivers" :value="'1'">1</b-form-radio>
														</div>
													</div>
												</div> -->
                                            </div>
											<div class="col-md-12"	>
												<h4 style="text-align: end;"> {{ $t('message.CAR')}} {{ $t('message.PRICE')}} {{car_price}} DKK / {{ $t ('message.MONTHLY')}} </h4>
												<h4 style="text-align: end;"> {{ $t ('message.OCCUPATIONAL_INJURY_INSURANCE')}} {{ $t('message.PRICE')}} {{work_price}} DKK / {{ $t ('message.MONTHLY')}} </h4>
												<h4 style="text-align: end;"> {{ $t ('message.PRICE')}}  {{price}} DKK / {{ $t ('message.MONTHLY')}} </h4>
											</div>	
										</div>
										 </tab-content>
								</form-wizard>
							</div>
							<!-- /.section-title -->
						</div>
					</div>
					<!-- <div class="col-sm-12" style="background:gainsboro; padding:25px;margin-bottom: 15px;" id="step-2-infobox" v-if="show_info_step2">
						<h5>{{ $t('message.WHERE_DO_YOUR_DRIVER')}} </h5>
						<p style="font-size:13px"> {{$t('message.STEP_2_MSG')}} </p> 
						<h5> {{$t('message.INJURIES_NUMBER')}} </h5> 
						<p style="font-size:13px"> {{$t('message.MANY_INJURIES')}} </p> 
						<h5 > {{$t('message.ROAD_SIDE')}} </h5>
						<p style="font-size:13px">
							{{$t('message.THOMAS')}} <a href="https://www.eadk.dk/eadk_vejhjaelp_1_02.pdf">{{$t('message.TERMS')}}</a>
						</p>
						<h5> {{$t('message.GLASS_DAMAGE')}} </h5>
						<p style="font-size:13px"> {{$t('message.CONNECTION_WITH_GLASS')}} </p>
						<h5> {{$t('message.OPERATING_LOSS')}} </h5>
						<p style="font-size:13px"> {{$t('message.COMPENSATION_PER')}} </p>
						<h5> {{$t('message.QUESTION')}} </h5>

						
						<p style="font-size:13px"> {{$t('message.CONTACT')}} <a href = "mailto:forsikring@dantaxi.dk" style="font-weight: bold;
						text-decoration: underline;
						font-size: 14px;
						color: rgba(43,172,102,255);">forsikring@dantaxi.dk</a> </p> 
					</div> -->
				</div>
				<div class="row"> </div>
			</div>
		</div>
	</div>
</template>
<script>
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'   
import Vue from 'vue'
import { Datetime } from 'vue-datetime';

export default {
    components: {
      FormWizard,
      TabContent,
	  Datetime
    },

    data(){
        return{
			name:'',
			email:'',
			phone:'',
			undervogn: '',
			cvr:'',
			type:'',
			dr_number:'',
			reg_number:'',
			new_values:[],
			new_value:null,
			own_risks:[],
			own_risk:null,
			injuries:[],
			injury:null,
			areas:[],
			area:null,
			premium:0,
			car_price:0,
			work_price:0,
			car_add_on:0,
			work_add_on:0,
			ensure:0,
			dantaxi:0,
			car_add_ons:[],
			car_add_on_model: [],
			work_add_ons:[],
			work_add_on_model: [],
            address:'',
			zip_code:'',
			city:'',
			date:null,
			insurance : [],
			select_insurance:'',
			police_number:'',
			trucker_id:'',
            cars:0,
			employees:0,
			drivers:0,
			form_data:{},
			previous_insurance:'',
			agreement_id: '',
			status:false,
			step1: false,
			step2:false,
			step3:false,
            image : require("../../assets/images/dantaxi-header-new.jpg"),
			nem_id_data: [],
			show_nem_id: false,
			show_model:true,
			show_sms_verification: false,
			sms_data: [],
			sms_code: '',
			show_info_step2: false,
			sms_verify_complete:false,
			no_license:'0',
			car:'0',
          	work:'0',
			injuryValidFrom: new Date(),
			injuryComment: '',
			addOn1Date: new Date(),
        }
    },
	computed: {
		add_on_number() {
			let add_on_number = 0
			let car_add_on = 0
			let work_add_on = 0

			var multiplier = 1
			if(this.work_add_on_model[0] != '0') {
				multiplier = this.multiplier
			}
			this.car_add_on_model.forEach((add_on) => {
				car_add_on += parseFloat(add_on)
				add_on_number += parseFloat(add_on)
			})
			this.work_add_on_model.forEach((add_on) => {
				work_add_on += parseFloat(add_on) * multiplier
				add_on_number += parseFloat(add_on) * multiplier
			})
			this.car_add_on = car_add_on
			this.work_add_on = work_add_on
			this.work_price = (this.work_add_on / 12).toFixed(2)
			
			return add_on_number
		},
		multiplier() {
			let employees = this.employees != '' ? this.employees : 0
			let drivers = this.drivers != '' ? this.drivers : 0
			let sum = parseFloat(employees) + parseFloat(drivers)
			
			return sum
		},

		price() {
			let premium = parseFloat(this.premium)
			
			let ensure = parseFloat(this.ensure)
			let dantaxi = parseFloat(this.dantaxi)
			
			let ensure_kickback = ensure != 0 ? (premium * ensure) / 100  : 0
			let dantaxi_kickback = dantaxi != 0 ? ((premium + ensure_kickback) * dantaxi) / 100 : 0

			premium = premium + ensure_kickback + dantaxi_kickback
			this.car_price = ((premium + this.car_add_on) / 12).toFixed(2)
			
			let price = (( premium + this.add_on_number)/12).toFixed(2)
			
			return price
		}
	},
    methods:{
		stepChange: function (prevIndex, nextIndex) {

			// if( (prevIndex = 0 && nextIndex == 1) || (prevIndex = 2 && nextIndex == 1) ){
			// 	this.show_info_step2 = true
			// } else {
			// 	this.show_info_step2 = false
			// }
      	},
	    async get_info(){
			let loader = this.$loading.show()
			try {
                const data_obj = await Vue.prototype.$http.get('/api/truckers/get-trucker/'+this.$route.params.id)
				if(data_obj.data.trucker) {
					let trucker = data_obj.data.trucker
					this.name = trucker.name,
					this.email = trucker.email
					this.cvr =  trucker.cvr,
					this.dr_number = trucker.truck_number
					this.phone = trucker.phone_number
					this.trucker_id = trucker.id
					this.undervogn = trucker.undervogn
					this.car = trucker.is_car_insurance
					this.work = trucker.is_work_insurance
					
					this.insurance = [];
					if(data_obj.data.insurance) {
						data_obj.data.insurance.forEach(element => {
							this.insurance.push(
							{label:element.name, code:element.id}
						)							
						});
					}

					if(trucker.address !=null) {
						this.address = trucker.address.address
						this.city = trucker.address.city
						this.zip_code =  trucker.address.zip_code
					}

					if(trucker.exiting_insurance !=null) {
						this.police_number = trucker.exiting_insurance.police_number
						this.date = trucker.exiting_insurance.termination_date
						let data  = this.insurance.find(element => element.code == trucker.exiting_insurance.insurance_company_id)
						this.select_insurance = data
					}

					if( trucker.vehicle != null ) {
						this.reg_number = trucker.vehicle.reg_number
					}

					if(trucker.trucker_agreement != null) {
						if(trucker.trucker_agreement.previous_insurance	 == '1') {
							this.previous_insurance = '1'
							this.status = true
							this.show_model = true
							document.getElementById('previous_insurance_1').checked = true;

						} else {
							this.previous_insurance = '0'
							this.status = false
							document.getElementById('previous_insurance_2').checked = true;
						}
					}

					if(trucker.trucker_agreement) {
						this.agreement_id = trucker.trucker_agreement.id
						this.area = trucker.trucker_agreement.area ? {label:trucker.trucker_agreement.area.title,code:trucker.trucker_agreement.area.id} : null
						this.new_value = trucker.trucker_agreement.area ? {label:trucker.trucker_agreement.new_value.title,code:trucker.trucker_agreement.new_value.id} : null
						this.own_risk = trucker.trucker_agreement.area ? {label:trucker.trucker_agreement.own_risk.title,code:trucker.trucker_agreement.own_risk.id} : null
						this.injury = trucker.trucker_agreement.area ? {label:trucker.trucker_agreement.injury.title,code:trucker.trucker_agreement.injury.id} : null
						
						this.car_add_ons.forEach((add_on, index) => {
							if(index == 0) {
								trucker.trucker_agreement.addon_1 ? (trucker.trucker_agreement.addon_1 == 1 ? this.car_add_on_model[index] = add_on.price  : this.car_add_on_model[index] = '0') : this.car_add_on_model[index] = '0'
							} else if(index == 1) {
								trucker.trucker_agreement.addon_2 ? (trucker.trucker_agreement.addon_2 == 1 ? this.car_add_on_model[index] = add_on.price  : this.car_add_on_model[index] = '0') : this.car_add_on_model[index] = '0'
							}
						})
						
						this.work_add_ons.forEach((add_on, index) => {
							if(index == 0) {
								// trucker.trucker_agreement.addon_3 ? (trucker.trucker_agreement.addon_3 == 1 ? this.work_add_on_model[index] = add_on.price  : this.work_add_on_model[index] = '0') : this.work_add_on_model[index] = '0'

								this.work_add_on_model[index] = '0'
								if( this.work == 1 ) {
									this.work_add_on_model[index] = add_on.price
								}
							}
						})

						this.injuryValidFrom = trucker.trucker_agreement.injury_valid_from
						this.injuryComment = trucker.trucker_agreement.injury_comment
						this.addOn1Date = trucker.trucker_agreement.addon_1_date
						
						this.get_premium()
					}

					if(trucker.multiply_price !=null) {
						this.cars = trucker.multiply_price.number_of_cars,
						this.employees = trucker.multiply_price.number_of_employee,
						this.drivers = trucker.multiply_price.number_of_drivers
					}
				}

				loader.hide()
			} catch (e) {
				loader.hide()
				this.$store.dispatch("notifications_alert/error", e.response.data.message)
				setTimeout( () => this.$router.push({ path: '/login'}), 3000);
			}
		},
		async add_insurance(){
            try {
                if(this.select_insurance == '' || this.police_number =='' || this.date ==='' || this.select_insurance == null) {
					this.$store.dispatch("notifications_alert/error", this.$t('message.REQUIRED_FIELD'))
					return
				} else {
					let form_data = {
						select_insurance:this.select_insurance,
						police_number: this.police_number,
						date: this.date,
						name:this.name,
						cvr:this.cvr,
						email:this.email,
						trucker_id :this.trucker_id,
						token : this.$route.params.token,
					    locale:localStorage.getItem('lang'),
						admin:true
					}

					let loader = this.$loading.show()
                    
					try {
						let data_obj = await Vue.prototype.$http.post('/api/step/insurance-info', form_data)
						loader.hide();
						if(data_obj.data.status)
						{
							this.status = false
					        this.$refs['insurrance-ons'].hide()
							document.getElementsByClassName('wizard-btn')[1].click()
							return true
						}
					} catch (e) {
						loader.hide()
						this.$store.dispatch("notifications_alert/error", e.response.data.message)

					}
				 }
			} catch (e) {
				this.$store.dispatch("notifications_alert/error", e.response.data.message)

			}
		},
		async get_premium() {
			if(this.area !== null && this.new_value !== null && this.own_risk !== null && this.injury !== null) {

				let loader = this.$loading.show()
				
				try {
					let form_data = {
						area_id : this.area.code,
						new_value_id : this.new_value.code,
						own_risk_id : this.own_risk.code,
						injury_id : this.injury.code
					}
					let resp = await Vue.prototype.$http.post('/api/price-plan/get-premium',form_data)
					this.premium = resp.data.data.price_plans ? resp.data.data.price_plans.premium : 0
					this.ensure = resp.data.data.price_plans ? (resp.data.data.price_plans.ensure ? resp.data.data.price_plans.ensure : 0) : 0
					this.dantaxi = resp.data.data.price_plans ? (resp.data.data.price_plans.dantaxi ? resp.data.data.price_plans.dantaxi : 0) : 0

					loader.hide()
				} catch (e) {
					this.premium = 0
					this.ensure = 0
					this.dantaxi = 0
					loader.hide()
				}
			}
		},
		async get_areas() {
            try {
               let resp = await Vue.prototype.$http.get('/api/area/list')
               resp.data.data.areas.forEach((area) => {
                   this.areas.push({
                       label: area.title,
                       code: area.id
                   })
               })
            } catch (e) {
               this.$store.dispatch('notifications_alert/error', this.$t('message.SOMETHING_WENT_WRONG'))
            }
        },

        async get_new_values() {
            try {
               let resp = await Vue.prototype.$http.get('/api/new-value/list')
               resp.data.data.new_values.forEach((new_value) => {
                   this.new_values.push({
                       label: new_value.title,
                       code: new_value.id
                   })
               })
            } catch (e) {
               this.$store.dispatch('notifications_alert/error', this.$t('message.SOMETHING_WENT_WRONG'))
            }
        },
        
        async get_own_risks() {
            try {
               let resp = await Vue.prototype.$http.get('/api/own-risk/list')
               resp.data.data.own_risks.forEach((own_risk) => {
                   this.own_risks.push({
                       label: own_risk.title,
                       code: own_risk.id
                   })
               })
            } catch (e) {
               this.$store.dispatch('notifications_alert/error', this.$t('message.SOMETHING_WENT_WRONG'))
            }
        },

        async get_injuries() {
            try {
               let resp = await Vue.prototype.$http.get('/api/injury/list')
               resp.data.data.injuries.forEach((injury) => {
                   this.injuries.push({
                       label: injury.title,
                       code: injury.id
                   })
               })
            } catch (e) {
               this.$store.dispatch('notifications_alert/error', this.$t('message.SOMETHING_WENT_WRONG'))
            }
        },

		async get_add_ons(type) {

			let form_data = {
				search_filter : 'type',
				search_key : '',
				pagination : 'false',
				type: type
			}

			try {
				let resp = await Vue.prototype.$http.post('/api/add-on/search', form_data)
				if(type === 1) {
					this.car_add_ons = resp.data.data.add_ons.data
				} else if(type === 2) {
					this.work_add_ons = resp.data.data.add_ons.data
				}
				
			} catch (e) {
				this.$store.dispatch('notifications_alert/error', this.$t('message.SOMETHING_WENT_WRONG'))
			}
		},

        async get_data() {
            let loader = this.$loading.show()

            try {
               await this.get_areas()
               await this.get_new_values()
               await this.get_own_risks()
               await this.get_injuries()
			   await this.get_add_ons(1)
			   await this.get_add_ons(2)
               loader.hide()
            } catch (e) {
               this.$store.dispatch('notifications_alert/error', this.$t('message.SOMETHING_WENT_WRONG'))
               loader.hide()
            }
        },

		async validateFirstStep() {
			const valid = await  this.$validator.validateAll()
			if(valid) {
				if(this.car == '0') {
					this.$store.dispatch("notifications_alert/error", this.$t('message.SELECT_CAR_OPTION'))
					return false
				}

				if(this.previous_insurance == '') {
					this.$store.dispatch("notifications_alert/error", this.$t('message.	SELECT_INSURANCE'))
					return false
				}

				let form_data = {
					name:this.name,
					email: this.email,
					cvr: this.cvr,
					dr_number: this.dr_number,
					phone: this.phone,
					undervogn: this.undervogn,
					reg_number: this.reg_number,
					address:this.address,
					city:this.city,
					zip_code :this.zip_code,
					is_car_insurance: this.car,
					is_work_insurance : this.work,
					previous_insurance: this.previous_insurance,
					address_id:this.address_id,
					id:this.trucker_id,
					locale:localStorage.getItem('lang')
				}
				console.log(form_data)
				let loader = this.$loading.show()

				try {
					let data_obj = await Vue.prototype.$http.post('/api/truckers/update-trucker', form_data)
					if( data_obj.data.id ) {
						this.step1 = true

						this.get_info()

						loader.hide()
						return true
					}
				} catch (e) {
					loader.hide()
					this.$store.dispatch("notifications_alert/error", e.response.data.message)
				}

				return false
				
				if(this.previous_insurance =='0') {

					
					
					// let form_data = {
					// 		address: this.address,
					// 		zip_code: this.zip_code,
					// 		city: this.city,
					// 		previous_insurance : this.previous_insurance,
					// 		trucker_id : this.trucker_id,
					// 		name :this.name,
					// 		email:this.email,
					// 		cvr: this.cvr,
					// 		phone:this.phone,
					// 		undervogn: this.undervogn,
					// 		dr_number:this.dr_number,
					// 		is_car_insurance: this.car,
					// 		is_work_insurance : this.insurance,
					// 		reg_number: this.reg_number,
					// 		locale:localStorage.getItem('lang')
					// }

					// try
					// {
					// 	let data_obj = await Vue.prototype.$http.post('/api/step/add-trucker-info', form_data)
					// 	loader.hide()
					// 	if(data_obj.data.status)
					// 	{
					// 		this.select_insurance = '',
					// 		this.police_number = '',
					// 		this.date = ''
					// 		this.status = true
					// 		this.agreement_id = data_obj.data.trucker.trucker_agreement.id
					// 		this.step1 = true

					// 		if(data_obj.data.trucker) {
					// 			let trucker = data_obj.data.trucker
					// 			this.name = trucker.name,
					// 			this.email = trucker.email
					// 			this.cvr =  trucker.cvr,
					// 			this.dr_number = trucker.truck_number
					// 			this.phone = trucker.phone_number
					// 			this.trucker_id = trucker.id

					// 			this.insurance = [];
					// 			if(data_obj.data.insurance)
					// 			{
					// 				data_obj.data.insurance.forEach(element => {
					// 					this.insurance.push(
					// 					{label:element.name, code:element.id}
					// 				)							
					// 				});
					// 			}

					// 			if(trucker.address !=null)
					// 			{
					// 				this.address = trucker.address.address
					// 				this.city = trucker.address.city
					// 				this.zip_code =  trucker.address.zip_code
					// 			}

					// 			if(trucker.exiting_insurance !=null)
					// 			{
					// 				this.police_number = trucker.exiting_insurance.police_number
					// 				this.date = trucker.exiting_insurance.termination_date
					// 				let data  = this.insurance.find(element => element.code == trucker.exiting_insurance.insurance_company_id)
					// 				this.select_insurance = data
					// 			}
					// 			if(trucker.trucker_agreement != null)
					// 			{
					// 				if(trucker.trucker_agreement.previous_insurance	 == '1')
					// 				{
					// 					this.previous_insurance = '1'
					// 					this.status = true
					// 					this.show_model = true
					// 					document.getElementById('previous_insurance_1').checked;

					// 				}
					// 				else
					// 				{
					// 					this.previous_insurance = '0'
					// 					this.status = true
					// 					document.getElementById('previous_insurance_2').checked;
					// 				}
					// 			}

					// 			if(trucker.trucker_agreement) {
					// 				this.agreement_id = trucker.trucker_agreement.id
					// 				this.area = trucker.trucker_agreement.area ? {label:trucker.trucker_agreement.area.title,code:trucker.trucker_agreement.area.id} : null
					// 				this.new_value = trucker.trucker_agreement.area ? {label:trucker.trucker_agreement.new_value.title,code:trucker.trucker_agreement.new_value.id} : null
					// 				this.own_risk = trucker.trucker_agreement.area ? {label:trucker.trucker_agreement.own_risk.title,code:trucker.trucker_agreement.own_risk.id} : null
					// 				this.injury = trucker.trucker_agreement.area ? {label:trucker.trucker_agreement.injury.title,code:trucker.trucker_agreement.injury.id} : null
									
					// 				this.car_add_ons.forEach((add_on, index) => {
					// 					if(index == 0) {
					// 						trucker.trucker_agreement.addon_1 ? (trucker.trucker_agreement.addon_1 == 1 ? this.car_add_on_model[index] = add_on.price  : this.car_add_on_model[index] = '0') : this.car_add_on_model[index] = '0'
					// 					} else if(index == 1) {
					// 						trucker.trucker_agreement.addon_2 ? (trucker.trucker_agreement.addon_2 == 1 ? this.car_add_on_model[index] = add_on.price  : this.car_add_on_model[index] = '0') : this.car_add_on_model[index] = '0'
					// 					}
					// 				})
									
					// 				this.work_add_ons.forEach((add_on, index) => {
					// 					if(index == 0) {
					// 						trucker.trucker_agreement.addon_3 ? (trucker.trucker_agreement.addon_3 == 1 ? this.work_add_on_model[index] = add_on.price  : this.work_add_on_model[index] = '0') : this.work_add_on_model[index] = '0'
					// 					}
					// 				})
									
					// 				this.get_premium()
					// 			}

					// 			if(trucker.multiply_price !=null)
					// 			{
					// 				this.cars = trucker.multiply_price.number_of_cars,
					// 				this.employees = trucker.multiply_price.number_of_employee,
					// 				this.drivers = trucker.multiply_price.number_of_drivers
					// 			}
					// 		}

					// 		return true
					// 	}
					// }
					// catch (e)
					// {
					// 	loader.hide()
					// 	this.$store.dispatch("notifications_alert/error", e.response.data.message)
					// }
				} else {
					
					let loader = this.$loading.show()

					let form_data = {
						address: this.address,
						zip_code: this.zip_code,
						city: this.city,
						previous_insurance: this.previous_insurance,
						trucker_id : this.trucker_id,
						name :this.name,
						email:this.email,
						cvr: this.cvr,
						phone:this.phone,
						undervogn: this.undervogn,
						dr_number:this.dr_number,
						is_car_insurance: this.car,
						is_work_insurance : this.insurance,
						reg_number: this.reg_number,
						locale:localStorage.getItem('lang')
					}

					this.status = true

					try 
					{
						let data_obj = await Vue.prototype.$http.post('/api/step/add-trucker-info', form_data)
						loader.hide()
						if(data_obj.data.status)
						{
							if(data_obj.data.trucker)
							{
								let trucker = data_obj.data.trucker
								this.name = trucker.name,
								this.email = trucker.email
								this.cvr =  trucker.cvr,
								this.dr_number = trucker.truck_number
								this.phone = trucker.phone_number
								this.trucker_id = trucker.id
								
								this.insurance = [];
								if(data_obj.data.insurance)
								{
									data_obj.data.insurance.forEach(element => {
										this.insurance.push(
										{label:element.name, code:element.id}
									)							
									});
								}

								if(trucker.address !=null)
								{
									this.address = trucker.address.address
									this.city = trucker.address.city
									this.zip_code =  trucker.address.zip_code
								}

								if(trucker.exiting_insurance !=null)
								{
									this.police_number = trucker.exiting_insurance.police_number
									this.date = trucker.exiting_insurance.termination_date
									let data  = this.insurance.find(element => element.code == trucker.exiting_insurance.insurance_company_id)
									this.select_insurance = data
								}
								if(trucker.trucker_agreement != null)
								{
									if(trucker.trucker_agreement.previous_insurance	 == '1')
									{
										this.previous_insurance = '1'
										this.status = true
										this.show_model = true
										document.getElementById('previous_insurance_1').checked;

									}
									else
									{
										this.previous_insurance = '0'
										this.status = true
										document.getElementById('previous_insurance_2').checked;
									}
								}

								if(trucker.trucker_agreement) {
									this.agreement_id = trucker.trucker_agreement.id
									this.area = trucker.trucker_agreement.area ? {label:trucker.trucker_agreement.area.title,code:trucker.trucker_agreement.area.id} : null
									this.new_value = trucker.trucker_agreement.area ? {label:trucker.trucker_agreement.new_value.title,code:trucker.trucker_agreement.new_value.id} : null
									this.own_risk = trucker.trucker_agreement.area ? {label:trucker.trucker_agreement.own_risk.title,code:trucker.trucker_agreement.own_risk.id} : null
									this.injury = trucker.trucker_agreement.area ? {label:trucker.trucker_agreement.injury.title,code:trucker.trucker_agreement.injury.id} : null
									
									this.car_add_ons.forEach((add_on, index) => {
										if(index == 0) {
											trucker.trucker_agreement.addon_1 ? (trucker.trucker_agreement.addon_1 == 1 ? this.car_add_on_model[index] = add_on.price  : this.car_add_on_model[index] = '0') : this.car_add_on_model[index] = '0'
										} else if(index == 1) {
											trucker.trucker_agreement.addon_2 ? (trucker.trucker_agreement.addon_2 == 1 ? this.car_add_on_model[index] = add_on.price  : this.car_add_on_model[index] = '0') : this.car_add_on_model[index] = '0'
										}
									})
									
									this.work_add_ons.forEach((add_on, index) => {
										if(index == 0) {
											// trucker.trucker_agreement.addon_3 ? (trucker.trucker_agreement.addon_3 == 1 ? this.work_add_on_model[index] = add_on.price  : this.work_add_on_model[index] = '0') : this.work_add_on_model[index] = '0'

											this.work_add_on_model[index] = '0'
											if( this.work == 1 ) {
												this.work_add_on_model[index] = add_on.price
											}
										}
									})
									
									this.get_premium()
								}

								if(trucker.multiply_price !=null)
								{
									this.cars = trucker.multiply_price.number_of_cars,
									this.employees = trucker.multiply_price.number_of_employee,
									this.drivers = trucker.multiply_price.number_of_drivers
								}
							}

							this.step1 = true
							return true
						}
					} 
					catch (e)
					{
						loader.hide()
						this.$store.dispatch("notifications_alert/error", e.response.data.message)
					}
				}
			} else {
				return false
			}
			
        },
		async validateSecondStep() {
			this.step2 = true

			let form_data = {
				area_id: this.area.code,
				new_value_id: this.new_value.code,
				own_risk_id: this.own_risk.code,
				injury_id : this.injury.code,
				agreement_id: this.agreement_id,
				token : this.$route.params.token,
				locale:localStorage.getItem('lang'),
				addon_1_date: this.addOn1Date,
				admin: true
			}

			this.car_add_on_model.forEach((add_on, index) => {
				let i = index + 1
				form_data['addon_'+i] = add_on === '0' ? 0 : 1
			})

			if(this.injury.code != '1')
			{
				if(this.status == true)
				{
					console.log('showing insurance pop up');
                    this.$refs['insurrance-ons'].show()
					return false
				}
			}
			

			let loader = this.$loading.show()

			try
			{
				let data_obj = await Vue.prototype.$http.post('/api/step/save-step-2', form_data)
				loader.hide()
				if(data_obj.data.status)
				{
					this.status = true
					return true
				}
			}
			catch (e)
			{
				loader.hide()
				this.$store.dispatch("notifications_alert/error", e.response.data.message)
			}
        },
		async validateThirdStep() {
            this.step3 = true
			// this.onComplete()
			// let loader = this.$loading.show()
            // if(this.sms_verify_complete ==  false) {
            //     try {
			// 	// this.show_nem_id = true
			// 	this.show_sms_verification = true
			// 	// window.addEventListener('message', this.messageHandler)
			// 	let data_obj = await Vue.prototype.$http.post('/api/sms/generate', {
			// 		token: this.$route.params.token,
			// 		trucker_id: this.trucker_id
			// 	})
				
			// 	loader.hide()
			// 	if(data_obj.data.status == 200) {
			// 		this.sms_data = data_obj.data.data
			// 		this.$refs['sms-verification'].show()
			// 		return true
			// 	}

			// 	} catch (e) {
			// 		loader.hide()
			// 		this.$store.dispatch("notifications_alert/error", e.response.data.message)
			// 	}  
			// }
			// loader.hide()

			return true

        },
        async onComplete()
        {
			
			let form_data = {
				agreement_id: this.agreement_id,
				token: this.$route.params.token,
				locale: localStorage.getItem('lang'),
				cars: this.cars,
				employees: this.employees,
				drivers: this.drivers,
				injury_valid_from: this.injuryValidFrom,
				injury_comment: this.injuryComment,
			}

			this.work_add_on_model.forEach((add_on, index) => {
				let i = index + 3
				form_data['addon_'+i] = add_on === '0' ? 0 : 1
			})

			let loader = this.$loading.show()

			try
			{
				let data_obj = await Vue.prototype.$http.post('/api/step/save-step-3', form_data)
				if(data_obj.data.status == 200) {
					let resp = await Vue.prototype.$http.get('/api/step/send-xml/' + this.trucker_id +  '?update=true')
					loader.hide()
					if( resp.data.status ) {
						this.$store.dispatch("notifications_alert/success", 'Opdatering gemt')

						setTimeout( () => this.$router.push({ path: '/admin/truckers'}), 3000);
					}
            
					return true
				}
			} catch (e) {
				loader.hide()
				this.$store.dispatch("notifications_alert/error", e.response.data.message)
			}
        },
		async messageHandler (event) {
			const postMessage = {}
			let message
			try {
				message = JSON.parse(event.data)
			} catch (e) {
				return
			}
			const iframe = this.$refs.iframe.contentWindow
			if (message.command === 'SendParameters') {
				postMessage.command = 'parameters'
				postMessage.content = this.nem_id_data.encoded_params
				console.log(JSON.parse(postMessage.content))
				console.log(`event origin: ${event.origin}`)
				iframe.postMessage(JSON.stringify(postMessage), event.origin)
			}

			if (message.command === 'changeResponseAndSubmit') {
				this.show_nem_id = false
		        this.$router.push({ name: "thank-you", params: {token:this.$route.params.token}, })
			} else {
				console.log('add error processing')
			}
		},
		async updateLanguage(lang) {
            let loader = this.$loading.show()

            try {
                await Vue.prototype.$http.get('/api/auth/lang/'+lang)
                localStorage.setItem('lang', lang)
                this.$i18n.locale =  localStorage.getItem('lang')
                loader.hide()
            } catch(e) {
               loader.hide();
            }
        }
    },

	async created()
	{
		this.name = '',
		this.email = '',
		this.cvr = '',
		this.dr_number = '',
		this.phone = ''
		this.undervogn = ''
		this.sms_verify_complete = false
		await this.get_data()
		if(this.$route.params.id) {
			this.get_info()
		}
	}
}
</script>

<style scoped>
body { -webkit-font-smoothing: antialiased; text-rendering: optimizeLegibility; font-family: 'Overpass', sans-serif; letter-spacing: 0px; font-size: 17px; color: #8d8f90; font-weight: 400; line-height: 32px; background-color: #edefef; }
h1, h2, h3, h4, h5, h6 { color: #25292a; margin: 0px 0px 10px 0px; font-family: 'Overpass', sans-serif; font-weight: 700; letter-spacing: -1px; line-height: 1; }
h1 { font-size: 34px; }
h2 { font-size: 28px; line-height: 38px; }
h3 { font-size: 22px; line-height: 32px; }
h4 { font-size: 20px; }
h5 { font-size: 17px; }
h6 { font-size: 12px; }
p { margin: 0 0 20px; line-height: 1.7; }
p:last-child { margin: 0px; }
ul, ol { }
a { text-decoration: none; color: #8d8f90; -webkit-transition: all 0.3s; -moz-transition: all 0.3s; transition: all 0.3s; }
a:focus, a:hover { text-decoration: none; color: #f85759; }



.page-caption { padding-bottom: 174px; }
.page-title { font-size: 46px; line-height: 1; color: #fff; font-weight: 600; text-align: center; }

.card-section { position: relative; bottom: 60px; }
.card-block { padding: 80px; }
.section-title { margin-bottom: 60px; }
.form-check input[type="checkbox"], .form-check-radio input[type="radio"] {
	visibility: visible  !important;
	opacity: 1;
}
.form-check .form-check-label {
	line-height: 39px !important;
	padding-left: 25px  !important;
}
.invalid-field {
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
}
.step_logo{
	height: 100px; width: 32%; margin-top: 60px;
}
#insurrance-ons___BV_modal_title_ {
    font-weight: bold;
}
@media screen and (max-width: 600px) {
  .card-block { 
	padding: 0px;
  }
  .step_logo{
	width: 100%;
	margin-top: 20px;
  }
  .page-header {
	height: 180px;
	background-size: 100% 90%;
  }
}

</style>
<style>
.vdatetime-input {
    border: 0  !important;
    width: 100%  !important;
}
</style>
<style scoped>
.iframe {
	min-width: 320px;
	min-height: 460px;
	width: 100%;
	height: calc(100vh - 212px);
	border: 0;
}
#nemid_overlay {
    background: rgba(0,0,0,0.7);
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 9;
}
.lang-holder {
    position: sticky;
    right: 25px;
    top: 10px;
    float: right;
}
</style>

<!-- <template>
    <div class="container-fluid">
        
        <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
                <h4 class="card-title">{{ $t('message.TRUCKER')}}</h4>
                <p class="card-category">{{ $t('message.LIST_OF_TRUCKER')}}</p>
            </template>
            <h5> {{ $t('message.USER_INFO')}} </h5>
            <hr>
            <div class="row">
                <div class="col-md-6 form-group">
                    <label class="label">{{ $t('message.NAME')}}</label>
                    <input name="name" v-model="name" type="text" class="form-control" v-validate="'required'" :class="{'is-invalid': errors.has('name') }" autocomplete="off"> 
                    <span v-show="errors.has('name')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD') }}</span>
                </div>
                <div class="col-md-6 form-group">
                    <label class="label">{{ $t('message.EMAIL')}}</label>
                    <input name="email" v-model="email" type="email" class="form-control" v-validate="'required'" :class="{'is-invalid': errors.has('email') }" autocomplete="off"> 
                    <span v-show="errors.has('email')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD') }}</span>
                </div>
                <div class="col-md-6 form-group">
                    <label class="label">CVR</label>
                    <input name="cvr" v-model="cvr" type="text" class="form-control" v-validate="'required|min:8|max:8'" :class="{'is-invalid': errors.has('cvr') }" autocomplete="off"> 
                    <span v-show="errors.has('cvr')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD_MIN_8') }}</span>
                </div>
                <div class="col-md-6 form-group">
                    <label class="label">{{ $t('message.TRUCK_NUMBER')}} </label>
                    <input name="truck_number" v-model="truck_number" type="number" class="form-control" v-validate="'required|min:6|max:6'" :class="{'is-invalid': errors.has('truck_number') }" autocomplete="off"> 
                    <span v-show="errors.has('truck_number')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD_MIN_6') }}</span>
                </div>					
                <div class="col-md-6 form-group">
                    <label class="label">{{ $t('message.TELEPHONE')}}</label>
                    <input name="phone" v-model="phone" type="number" class="form-control" v-validate="'required'" :class="{'is-invalid': errors.has('phone') }" autocomplete="off"> 
                    <span v-show="errors.has('phone')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD') }}</span>
                </div>
                <div class="col-md-6 form-group">
                    <label class="label">{{ $t('message.UNDERVOGN')}}</label>
                    <input name="undervogn" v-model="undervogn" type="text" class="form-control"  :class="{'is-invalid': errors.has('undervogn') }" autocomplete="off"> 
                    <span v-show="errors.has('undervogn')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD') }}</span>
                </div>
            </div>
            <div class="row" v-if="address_status == true">
                <div class="col-md-6 form-group">
                    <label class="label">Adresse</label>
                    <input name="address" v-model="address" type="text" class="form-control" v-validate="'required'" :class="{'is-invalid': errors.has('address') }" autocomplete="off"> 
                    <span v-show="errors.has('address')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD') }}</span>
                </div>
                <div class="col-md-6 form-group">
                    <label class="label">{{ $t('message.CITY')}}</label>
                    <input name="city" v-model="city" type="text" class="form-control" v-validate="'required'" :class="{'is-invalid': errors.has('city') }" autocomplete="off"> 
                    <span v-show="errors.has('city')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD') }}</span>
                </div>
                <div class="col-md-6 form-group">
                    <label class="label">{{ $t('message.ZIP_CODE')}}</label>
                    <input name="zip_code" v-model="zip_code" type="text" class="form-control" v-validate="'required'" :class="{'is-invalid': errors.has('zip_code') }" autocomplete="off"> 
                    <span v-show="errors.has('zip_code')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD') }}</span>
                </div>
            </div>
            <h5> {{ $t('message.VEHICLE')}} </h5>
            <hr>
            <div class="row">
                <div class="col-md-6 form-group">
                    <label class="label">{{ $t('message.CAR_NUMBER')}}: </label>
                    <input name="reg_number" v-model="reg_number" readonly type="text" class="form-control" autocomplete="off"> 
                </div>
                <div class="col-md-6 form-group">
                    <label class="label">{{ $t('message.FRAME_NO')}}</label>
                    <input name="frame_number" v-model="frame_number" readonly type="text" class="form-control" autocomplete="off"> 
                </div>
            </div>
            <h5> {{ $t('message.SEND_REQUEST') }}  </h5>
            <span style="display: inline-flex;">
                <b-form-checkbox id="checkbox-1" v-model="car" class="mr-4" name="checkbox-1" value="1" unchecked-value="0">
                    {{ $t('message.CAR') }} 
                </b-form-checkbox>
                <b-form-checkbox id="checkbox-2" v-model="insurance" name="checkbox-2" value="1" unchecked-value="0">
                    {{ $t('message.INSURANCE') }} 
                </b-form-checkbox>
            </span>
            <br />
            <hr>
            <h4 style="padding-bottom:20px">  {{ $t('message.YOUR_ADDRESS')}} </h4>
            <div class="row">
                <div class="col-md-6 form-group">
                    <label class="label">Adresse</label>
                    <input name="address" v-model="address" type="text" class="form-control" v-validate="'required'" :class="{'is-invalid': errors.has('address') }" autocomplete="off"> 
                    <span v-show="errors.has('address')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD') }}</span> </div>
                <div class="col-md-6 form-group">
                    <label class="label">{{ $t('message.ZIP_CODE')}}</label>
                    <input name="zip_code" v-model="zip_code" type="text" class="form-control" v-validate="'required'" :class="{'is-invalid': errors.has('zip_code') }" autocomplete="off"> 
                    <span v-show="errors.has('zip_code')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD') }}</span> </div>
                <div class="col-md-6 form-group">
                    <label class="label">{{ $t('message.CITY')}}</label>
                    <input name="city" v-model="city" type="text" class="form-control" v-validate="'required'" :class="{'is-invalid': errors.has('city') }" autocomplete="off"> 
                    <span v-show="errors.has('city')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD') }}</span> </div>
            </div>
            <span class="float-right">
                <b-button class="btn btn-info mr-2"   @click="edit_truckers()">{{ $t('message.UPDATE') }}</b-button>
                <b-button class=" btn btn-danger"   @click="$bvModal.hide('edit-trucker')"> {{ $t('message.CLOSE') }} </b-button>
            </span>
        </card>
    </div>
</template>
<script>

export default {
    data () {
      return {
        trucker: '',
          name:'',
          address_status:false,
          email:'',
          phone:'',
          cvr:'',
          address:'',
          city:'',
          zip_code:'',
          frame_number:'',
          truck_number:'',
          reg_number:'',
          car:'0',
          insurance:'0',
          id:'',
          address_id:'',
          undervogn: '',
        address:'',
        zip_code:'',
        city:'',
      }
    },
    computed: {
        truckers() {
            // return this.$store.getters['trucker/allTruckers']
            return this.$store.state.truckers
        },
        labels()
        {
          return {
              name:{title:this.$t('message.NAME')},
              email: {title:this.$t('message.EMAIL')},
              cvr: {title:"CVR"},
              truck_number: {title:this.$t('message.TRUCK_NUMBER')},
              reg_number: {title:this.$t('message.CAR') +' '+'Reg No'},
              serial_number: {title:this.$t('message.FRAME_NO')},
              is_work_insurance:{title:this.$t('message.WORK_INJURY')},
              has_reg_no: {title:this.$t('message.HAS_REG_NO')}
          }
        }
    },
    mounted() {
        this.get_trucker()
    },
    created() {
        console.log(this.trucker)
    },

    methods:{

        async get_trucker() {
            let loader = this.$loading.show()
            try 
            {
                const trucker = await this.$store.dispatch('trucker/get_trucker', this.$route.params.id)
                this.name = trucker.data.trucker.name
                this.email = trucker.data.trucker.email
                this.cvr = trucker.data.trucker.cvr
                this.truck_number = trucker.data.trucker.truck_number
                this.phone = trucker.data.trucker.phone_number
                this.undervogn = trucker.data.trucker.undervogn
                this.reg_number = trucker.data.trucker.reg_number
                this.serial_number = trucker.data.trucker.vehicle.serial_number

                this.address = trucker.data.trucker.address.address
                this.city = trucker.data.trucker.address.city
                this.zip_code = trucker.data.trucker.address.zip_code
                loader.hide()
            } catch(e) {
                this.$store.dispatch("notifications_alert/error", e.message)
                loader.hide()
            }

            // store.dispatch('app-user/fetchUser', { id: router.currentRoute.params.id })
        },

        async edit_truckers(){
                const valid = await this.$validator.validateAll()
            if (valid) {
                
                let form_data = {
                    name:this.name,
                    cvr: this.cvr,
                    email: this.email,
                    reg_number: this.reg_number,
                    address:this.address,
                    city:this.city,
                    zip_code :this.zip_code,
                    phone: this.phone,
                    undervogn: this.undervogn,
                    dr_number: this.dr_number,
                    is_car_insurance: this.car,
                    is_work_insurance : this.insurance,
                    address_id:this.address_id,
                    id:this.id,
                    locale:localStorage.getItem('lang')

                }

                if(this.car == '0')
                {
                    this.$store.dispatch("notifications_alert/error", this.$t('message.SELECT_CAR_OPTION'))
                    return

                }

                let loader = this.$loading.show()


                try 
                {
                     await this.$store.dispatch('trucker/update_trucker', form_data)
                    this.$store.dispatch("notifications_alert/success", this.$t('message.MSG_UPDATE_SUCC'))
                    this.$refs['edit-trucker'].hide()
                    loader.hide()

                } 
                catch (e) 
                {
                    loader.hide()
                    this.$store.dispatch("notifications_alert/error", e.response.data.message)
                }
            }
        },
        show(trucker)
        {
            this.reset_form();
            this.id = trucker.id
            this.name = trucker.name
            this.email =trucker.email
            this.cvr = trucker.cvr
            this.dr_number = trucker.truck_number
            this.reg_number = trucker.vehicle ? trucker.vehicle.reg_number : ''
            this.frame_number = trucker.vehicle ? trucker.vehicle.serial_number : ''
            this.car = trucker.is_car_insurance
            this.insurance = trucker.is_work_insurance
            this.phone = trucker.phone_number
            this.undervogn = trucker.undervogn
            if(trucker.address)
            {
                this.address_id = trucker.address.id
                this.address = trucker.address.address
                this.city =  trucker.address.city
                this.zip_code = trucker.address.zip_code
                this.address_status = true
            }
            else
            {
                this.address_status = false
            }
            this.$refs['edit-trucker'].show()
        },
        reset_form(){
            this.name = '',
            this.email = '',
            this.reg_number = '',
            this.frame_number = '',
            this.cvr = '',
            this.phone = '',
            this.undervogn = '',
            this.address = null ,
            this.city = null,
            this.zip_code = null
        }
    }
}
</script>
<style  >
.modal-content{
    margin-top: -66px !important;
}
#sms-verification .modal-content {
	margin-top: 100px !important;
} 
</style> -->